module.exports = __webpack_public_path__ + "img/img15.d15a882b.svg";